import { render } from "./Sidepane.vue?vue&type=template&id=38535e96"
import script from "./Sidepane.vue?vue&type=script&lang=js"
export * from "./Sidepane.vue?vue&type=script&lang=js"

import exportComponent from "D:\\projects\\paintcare\\pcsitelocator\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__